module.exports = __webpack_public_path__ + "static/ogImage-cb2d44e2c73736f4dc9e376c8f954da3.png";